<template>
    <div id="systemfunction">
        <HrrBreadcrumb PMname="其他功能" CMname="媒体检查管理" />
        <HrrDetailLayout>
            <template slot="head">
                {{title}}
            </template>
            <template slot="Form">
                <el-form status-icon :model="form" ref="form" :rules="rules" label-width="120px" class="el-form-module" :hide-required-asterisk="isView">
                    <!--<el-form-item label="开始时间：" prop="startTime">
                        <el-date-picker v-model="form.startTime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" disabled v-if="isAdd||isEdit"></el-date-picker>
                        <span v-if="isView">
                            {{form.startTime}}
                        </span>
                    </el-form-item>
                    <el-form-item label="结束时间：" prop="endTime">
                        <el-date-picker v-model="form.endTime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" disabled v-if="isAdd||isEdit"></el-date-picker>
                        <span v-if="isView">
                            {{form.endTime}}
                        </span>
                    </el-form-item>-->
                    <el-form-item label="检测时间：" prop="inspectionDate">
                        <el-date-picker v-model="form.inspectionDate" placeholder="检测时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" v-if="isAdd||isEdit"></el-date-picker>
                        <span v-if="isView">
                            {{form.inspectionDate}}
                        </span>
                    </el-form-item>
                    <el-form-item label="检测站点：" prop="siteId">
                        <el-select v-model="form.siteId" @change="changeSiteId" placeholder="请选择" v-if="isAdd||isEdit" filterable>
                            <el-option v-for="item in siteidData" :key="item.SiteId" :label="item.SiteName" :value="item.SiteId">
                            </el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.siteName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="检测媒体编号：" prop="lightBoxId">
                        <el-select v-model="form.lightBoxId" placeholder="请选择" v-if="isAdd||isEdit" filterable>
                            <el-option v-for="item in lightBoxCodeData" :key="item.lightBoxId" :label="item.lightBoxCode" :value="item.lightBoxId">
                            </el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.siteName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="检查人：" prop="usersName">
                        <el-input v-model="form.usersName" v-if="isAdd||isEdit" placeholder="多人使用逗号分开" ></el-input>
                        <span v-if="isView">
                            {{form.usersName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="巡检内容说明：" prop="checkupContect">
                        <el-input v-model="form.checkupContect" v-if="isAdd||isEdit" type="textarea" :rows="8"></el-input>
                        <span v-if="isView">
                            {{form.checkupContect}}
                        </span>
                    </el-form-item>
                    <el-form-item label="是否异常：" prop="isAbnormal">
                        <el-select v-model="form.isAbnormal" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="否" value="0"></el-option>
                            <el-option label="是" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button type="primary" @click="submitMForm('form')" v-if="isAdd||isEdit">提 交</el-button>
                <el-button @click="resetMForm('form')" v-if="isAdd||isEdit">重 置</el-button>
                <el-button type="info" @click="returnMForm()">返 回</el-button>
            </template>
        </HrrDetailLayout>
    </div>
</template>
<script>
export default {
    name: 'lightboxcheckupdetail',
    data() {
        return {
            form: {
                startTime: "",
                endTime: "",
                lightBoxId: "",
                usersName: "",
                isAbnormal: "",
                checkupContect: "",
                inspectionDate: "",
            },
            rules: {
                usersName: [{ required: true, message: '请输入检查人', trigger: 'blur' }],
                checkupContect: [{ required: true, message: '请输入检查日志内容', trigger: 'blur' }],
                inspectionDate: [{ required: true, message: '请输入检查时间', trigger: 'blur' }],
                isAbnormal: [{ required: true, message: '请选择是否异常', trigger: 'change' }]
            },
            siteidData: [],
            lightBoxCodeData:[],
            title: "",
            isView: false,
            isEdit: false,
            isAdd: false,
        }
    },
    methods: {
        submitMForm: function(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var apiUrl = this.$api.DeviceCheckUpLog.api+(this.isAdd ? "" : "/" + this.DeviceCheckUpLog.api);
                    var m = this.isAdd ? "POST" : "PUT";
                    this.$hrraxios({
                            method: m,
                            url: apiUrl,
                            data: this.form
                        })
                        .then(function(response) {
                            loading.close();
                            var data = response.data;
                            if (data.Success == true) {
                                Vuethis.$alert("提交成功！", {
                                    callback: action => {
                                        Vuethis.$router.push({ path: '/lightbox/checkup/' });
                                    }
                                });
                            } else {
                                Vuethis.$message({ message: data.Prompt, type: "error" });
                            }
                        }).catch(function(error) {
                            loading.close();
                            console.log(error);
                        })
                } else {
                    return false;
                }
            });
        },
        resetMForm: function(formName) {
            this.$refs[formName].resetFields();
        },
        returnMForm: function() {
            this.$router.go(-1);
        },
        initParamsData: function() {
            var myVuethis=this;
            //所属地铁站
            this.$hrraxios.get(this.$api.site.downlist)
                .then((response) => {
                    var data = response.data;
                    if (data.Success == true) {
                        myVuethis.siteidData = data.Data;
                    } else {
                        myVuethis.$message.error("数据初始化失败,请联系管理员");
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
        },
        changeSiteId(val) {
            this.adLightBoxDefault = val
            this.form.lightBoxId = ""
            this.lightBoxData();
        },
        lightBoxData() {
            var Vuethis = this;
            this.$hrraxios.get(this.$api.device.getNoDevice + "/" + this.adLightBoxDefault)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.lightBoxCodeData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        initData: function() {
            this.isView = false;
            this.isEdit = false;
            this.isAdd = false;
            var Hrrtype = this.$route.params.type; //类型
            var row = this.$route.meta.row;
            var info = "检查日志";
            if (Hrrtype != "add") {
                this.functionform = row;
                this.$route.meta.row = null;
            }
            if (Hrrtype == "view") {
                this.title = "查看" + info;
                this.isView = true;
            }
            if (Hrrtype == "edit") {
                this.title = "编辑" + info;
                this.isEdit = true;

            }
            if (Hrrtype == "add") {
                this.form.usersName=this.$store.state.userName;
                this.title = "新增" + info;
                this.isAdd = true;
            }
            var now=new Date();
            var weeks = new Array(7, 1, 2, 3, 4, 5, 6);
            var day=now.getDay();
            var currday=weeks[day];
            var start=now.setDate(now.getDate()-currday);
            this.form.startTime=new Date(start);
            var end=now.setDate(now.getDate()+7);
            this.form.endTime=new Date(end);
        }
    },
    created: function() {
        this.initData();
        this.initParamsData();
    }
}
</script>
<style>
.el-form-module {
    width: 500px;
}
</style>